// extracted by mini-css-extract-plugin
module.exports = {"categoriesForm":"CategoriesForm_categoriesForm__3ru-M","items":"CategoriesForm_items__2hzjN"};